module.exports = "<%=baseUrl%>/a8c874b93b3d848f39a71260c57e3863.cur";